<template>
  <div class="container">
    <div class="open_vip_title_container">
      <div class="open_vip_title">
        <div class="open_vip_title_main">
          <span class="open_vip_title_text">升级超级会员</span>
          <img src="https://files.wondercv.com/openVip/vip.png" class="vip_img" />
        </div>
        <span class="title_tip">尊享专属特权 求职一路开挂</span>
      </div>
      <img src="https://files.wondercv.com/openVip/kings.png" class="title_img" />
    </div>
    <div class="line"></div>
    <div class="open_vip_main_container">
      <div class="member_container" v-for="item in imgUrlList" :key="item.text">
        <img :src="item.url" alt="" class="member_img">
        <div class="member_text">{{ item.text }}</div>
      </div>
    </div>
    <div class="button" @click="buyMember">立即开通</div>
  </div>
</template>

<script>
import { envMixin } from '@/assets/js/mixin/global'

export default {
  name: "OperationPicker",
  mixins: [envMixin],
  data() {
    return {
      imgUrlList: [
        {
          url: 'https://files.wondercv.com/openVip/cvs_new.png',
          text: '15 份简历'
        },
        {
          url: 'https://files.wondercv.com/openVip/translation_new.png',
          text: '无限次翻译'
        },
        {
          url: 'https://files.wondercv.com/openVip/template_new.png',
          text: '模板任意选'
        },
        {
          url: 'https://files.wondercv.com/openVip/check_new.png',
          text: 'AI 智能检查'
        },
      ],
    }

  },
  methods: {
    buyMember () {
      if (this.isWxMini) {
        if (this.mobileOS === 'iOS') {
          this.$wechat.miniProgram.navigateTo({
            // url: `/pages/customService/customService`
            url: `/pages/memberPay/memberPay`
          })
        } else {
          this.$router.push('/buy/member/order')
        }
      } else {
        // window.location.href = `${process.env.VUE_APP_HOST}/buy/member/order`
        this.$router.push('/buy/member/order')
      }
      // window.location.href = `${process.env.VUE_APP_HOST}/account/users/buy_member1`
      // this.routeTo('/account/users/buy_member')
    },
    close() {
      this.$emit('close')
    },
    operation(obj) {
      this.$emit('operation', obj)
    }
  }
}
</script>

<style lang="scss" scoped>
.container {
  width: 100vw;
  height: auto;
  min-height: 200px;
  background-color: #fff;
  border-radius: 12px 12px 0 0;
  box-sizing: border-box;
  /* padding: 13px 0 0; */
}
.line {
  height: 1px;
  background: #f9f9f9;
  margin: 0 24px;
}
.open_vip_title_container {
  display: flex;
  width: 100%;
  height: 76px;
  /* border-bottom: 1px solid  #f9f9f9; */
  flex-direction: row;
  align-items: center;
  padding-left: 24px;
  justify-content: space-between;
  .open_vip_title {
    flex: 1;
  }
  .open_vip_title_main {
    flex: 1;
    flex-direction: row;
    align-items: center;
    display: flex;
  }
  .open_vip_title_text {
    color: #404040;
    font-size: 18px;
    font-weight: 500;
    line-height: 25px;
    margin-bottom: 2px;
  }
  .vip_img {
    width: 30px;
    height: 12px;
    margin-left: 6px;
  }
  .title_tip {
    color: #9c9c9c;
    font-size: 12px;
    font-weight: 400;
    line-height: 17px;
  }
  .title_img {
    width: 137px;
    height: 108px;
    /* position: relative; */
    /* top: -13px; */
    /* right: -20px; */
  }
}
.open_vip_main_container {
  display: flex;
  width: 100%;
  /* height: 117px; */
  padding: 18px 24px 24px 24px;
  justify-content: space-around;
  align-items: center;

  .member_container {
    display: flex;
    flex-direction: column;
    align-items: center;
  }
  .member_img {
    width: 50px;
    height: 50px;
    margin-bottom: 8px;
  }
  .member_text {
    font-size: 12px;
    font-weight: 300;
    line-height: 17px;
    color: #606060;
  }

}
.button {
  margin: 0 24px 30px 24px;
  width: 327px;
  text-align: center;
  background: linear-gradient(133deg, #FF9C62 0%, #FF6030 100%);
  border-radius: 6px;
  color: #FFFFFF;
  line-height: 48px;
  font-weight: 500;
  font-size: 16px;
}
</style>
